import React, { Component } from 'react';
import { Divider } from 'antd';
import { withDomains, RESTExecutor } from '../lib/domain';
import { showErrorInNotification } from '../lib/util';
import { Link } from 'react-router-dom';
import { CloudDownloadOutlined, InsertDriveFileOutlined, ArchiveOutlined, UnarchiveOutlined } from '@material-ui/icons';
import { COLORS } from '../pages/theme';


class InboxItem extends Component {
    constructor(props) {
        super(props)

        let data = this.props.data || {};

        this.state = {
            seen: data.seen
        };

        this.mark_seen = RESTExecutor.patch().config({
            label: 'mark_seen_report'
        }).callbacks((success) => {
            this.setState({ seen: true })
        }, (error) => {
            showErrorInNotification(error)
        }).connect(props.domains.reports);

        this.archive_report = RESTExecutor.patch().config({
            label: 'archive_report'
        }).callbacks((success) => {
            typeof props.onRefresh === 'function' && props.onRefresh()
        }, (error) => {
            showErrorInNotification(error)
        }).connect(props.domains.reports);

        this.unarchive_report = RESTExecutor.patch().config({
            label: 'unarchive_report'
        }).callbacks((success) => {
            typeof props.onRefresh === 'function' && props.onRefresh()
        }, (error) => {
            showErrorInNotification(error)
        }).connect(props.domains.reports);

        this.download_report = RESTExecutor.detail().config({
            label: 'download_report'
        }).callbacks((success) => {
            window.open(success.result.url, '_blank');
        }, (error) => {
            showErrorInNotification(error)
        }).connect(props.domains.reports);

    };

    render() {
        // let seen=((parseInt(Math.random()*100))%2)===0?false:true;
        let data = this.props.data || {};
        const { seen } = this.state;
        // let seen=data.seen;
        let owned = data.report_type;
        let archived = data.archived;
        let created_time = data.generated_at;
        let name=data.name||"";

        return <Link to={`/reports/${archived ? 'archived' : 'inbox'}/${data.id}`}><div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            padding: 26,
            color: seen?COLORS.secondary:COLORS.black,
            backgroundColor:seen?null:COLORS.primary_off_selected,
            fontWeight:seen?null:'bold'
        }}>
            <div style={{
                width: 200
            }}>
                {created_time}
            </div>

            <div style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                paddingLeft: 60
            }}>
                <InsertDriveFileOutlined />&nbsp;&nbsp;&nbsp;
                <span style={{
                    color: COLORS.black
                }}>{name}</span>
            </div>

            <div style={{
                width: 240,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
            }}>
                <span style={{
                    fontSize:12,
                    textTransform:'uppercase'
                }}>{owned}</span>
                <Divider type='vertical' style={{
                    marginLeft: 12, marginRight: 12
                }} />
                <div
                    title="Download"
                    className='hand-cursor'
                    style={{
                        display: 'flex',
                        alignItems: 'center'
                    }}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation()
                        this.download_report.forId(data.id).execute()
                    }}
                >
                    <CloudDownloadOutlined />&nbsp;&nbsp;&nbsp;
                    <span>Download</span>
                </div>
                <Divider type='vertical' style={{
                    marginLeft: 12, marginRight: 12
                }} />
                {archived ? <UnarchiveOutlined 
                className='hand-cursor'
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation()
                        this.unarchive_report.forId(data.id).execute();

                }}
                titleAccess="Unarchive"/>
                    :
                    <ArchiveOutlined
                        className='hand-cursor'

                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation()
                            this.archive_report.forId(data.id).execute();
                        }}
                        titleAccess="Archive"
                    />

                }


            </div>

        </div>
        </Link>

    }
}

export default withDomains(InboxItem, "reports");
